export function UTCToLocal(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
}

export function localToUTC(date) {
    var newDate = new Date(date)
    newDate.setMinutes(newDate.getMinutes() + newDate.getTimezoneOffset());
    return newDate;
}

export function now() {
    return new Date();
}

export function dateEquals(a, b) {
    return (
        isFinite(a) && isFinite(b) ?
        a>=b && a<=b:
        NaN
    );
}

export function dateDayDifference(a, b) {
    return Math.round((a-b)/86400000);
}

export const dayOfWeekMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export function getDayOfWeek(date) {
    return dayOfWeekMap[date.getDay()];
}

import moment from "moment";
export function timeToDate(time) {
    return moment(time, 'HH:mm:ss').toDate();
}
